import React from "react";
import "./template.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index";
import { Redirect } from "react-router-dom";

export class Form extends React.Component {
  constructor(props) {
    super(props);
    let inputs = {};
    props.data.formFields.map(input => {
      return (inputs[input.inputName] = "");
    });
    this.state = {
      inputs: inputs,
      sent: false,
      errors: {},
      usernameValidation: null
    };
  }

  componentDidMount() {
    window.scrollTo(0, 600);
  }

  updateValue(inputName, val) {
    let inputs = { ...this.state.inputs };
    inputs[inputName] = val;
    this.setState({
      inputs: inputs
    });
  }

  validateInputs = inputs => {
    let errors = {};
    this.props.data.formFields.forEach(field => {
      if (field.validation) {
        if (
          this.state.inputs[field.inputName].length < field.validation.reqLength
        ) {
          errors[field.inputName] = field.validation.errText;
        }
      }
    });
    this.setState({
      errors: errors
    });
    if (Object.keys(errors).length === 0) {
      return true;
    } else {
      this.scrollToError("#" + Object.keys(errors)[0]);
      return false;
    }
  };

  onSubmit = () => {
    let isValid = this.validateInputs(this.state.inputs);
    if (this.props.data.submitLink && !this.state.sent && isValid) {
      let error = null;
      this.setState(
        {
          usernameValidation: true
        },
        () => {
          fetch(
            "https://ops-adduser.builtwithdark.com/validateUsername/" +
              this.state.inputs.username,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
              }
            }
          )
            .then(response => {
              if (!response.ok) {
                error = true;
              }
              return response.json();
            })
            .then(response => {
              if (error) {
                this.setState({
                  usernameValidation: response
                });
              } else {
                this.submit();
              }
            })
            .catch(err => {
              this.setState({
                usernameValidation: "Unexpected error: " + err
              });
            });
        }
      );
    }
  };

  scrollToError(selector) {
    const el = document.querySelector(selector);
    el.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
  }

  submit() {
    fetch(this.props.data.submitLink, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ ...this.state.inputs, email: this.props.email })
    });
    let inputs = Object.keys(this.state.inputs).reduce((dict, key) => {
      dict[key] = "";
      return dict;
    }, {});
    this.setState({
      usernameValidation: null,
      sent: true,
      inputs
    });
  }

  render() {
    let { data } = this.props;
    let buttonClasses =
      data.showBtn.class + " form-button " + (this.state.sent ? "sent" : "");
    if (this.state.sent) {
      return (
        <Redirect
          to={{
            pathname: "/beta",
            state: {
              submitted: true
            }
          }}
        />
      );
    } else {
      return (
        <div className={"Form Center " + data.class}>
          {data.title && data.title.text && (
            <h1 className={data.title.class || ""}>{data.title.text}</h1>
          )}
          {data.paragraph && data.paragraph.text && (
            <p className={data.paragraph.class || ""}>{data.paragraph.text}</p>
          )}
          {data.formFields &&
            data.formFields.length > 0 &&
            data.formFields.map((formField, idx) => (
              <FormField
                val={this.state.inputs[formField.inputName]}
                updateValue={this.updateValue.bind(this)}
                key={formField.title.text + idx + this.state.error}
                data={formField}
                showErrors={
                  formField.inputName === "username"
                    ? this.state.usernameValidation
                    : this.state.errors[formField.inputName]
                }
              />
            ))}
          {data.showBtn && (
            <button
              type="submit"
              className={buttonClasses}
              onClick={this.onSubmit.bind(this)}
            >
              {this.state.sent ? "Sent" : data.showBtn.text}
            </button>
          )}
        </div>
      );
    }
  }
}

const FormField = ({ data, updateValue, val, showErrors }) => {
  return (
    <div className={"form-field " + data.class || ""}>
      {data.title && data.title.text && (
        <h1 className={data.title.class || ""} id={data.inputName}>
          {data.title.text}
        </h1>
      )}
      {data.subtitle && data.subtitle.text && (
        <h1 className={data.subtitle.class || ""}>{data.subtitle.text}</h1>
      )}
      {data.paragraph && data.paragraph.text && (
        <p className={data.paragraph.class || ""}>{data.paragraph.text}</p>
      )}
      {showErrors ? (
        showErrors === true ? (
          <h1 className="light-purple paragraph-text">
            {" "}
            <FontAwesomeIcon
              className="light-purple spinner"
              icon="spinner"
              spin
            />{" "}
            Validating {data.displayName} with server
          </h1>
        ) : (
          <h1 className="light-purple paragraph-text">{showErrors}</h1>
        )
      ) : null}
      {data.input ? (
        data.input.singleLine ? (
          <input
            onChange={ev => updateValue(data.inputName, ev.target.value)}
            className={"form-input " + data.input.class}
            value={val}
          ></input>
        ) : (
          <textarea
            onChange={ev => updateValue(data.inputName, ev.target.value)}
            className={"form-input " + data.input.class}
            value={val}
          ></textarea>
        )
      ) : null}
    </div>
  );
};

export default Form;
